import { SVGProps } from 'react';
const SvgArrowDownLeftMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 7 7 17M15 17H7V9"
    />
  </svg>
);
export default SvgArrowDownLeftMd;
